// extracted by mini-css-extract-plugin
export default {"passwordResetFormInner":"PasswordResetForm_passwordResetFormInner__wdluZ"};